import { wrapModalPromise } from '@/utils/modal';

import style from './index.module.scss';

import { LeaveGroupModal } from './LeaveGroupModal';
import { LeaveGroupSignerModal } from './LeaveGroupSignerModal';
import { RenameGroupModal } from './RenameGroupModal';
import { RemoveGroupMemberModal } from './RemoveGroupMemberModal';
import { ApplyToJoinGroupModal } from './ApplyToJoinGroupModal';
import { PinPostToGroupModal } from './PinPostToGroupModal';

export enum GROUP_MODAL_TYPE {
  LEAVE_GROUND = 'LEAVE_GROUND',
  REMOVE_GROUP_MEMBER = 'REMOVE_GROUP_MEMBER',
  LEAVE_GROUP_SIGNER = 'LEAVE_GROUP_SIGNER',
  RENAME_GROUP = 'RENAME_GROUP',
  JOIN_GROUP = 'JOIN_GROUP',
  PIN_ARTICLE = 'PIN_ARTICLE',
}

const modalMap = {
  [GROUP_MODAL_TYPE.LEAVE_GROUND]: LeaveGroupModal,
  [GROUP_MODAL_TYPE.LEAVE_GROUP_SIGNER]: LeaveGroupSignerModal,
  [GROUP_MODAL_TYPE.REMOVE_GROUP_MEMBER]: RemoveGroupMemberModal,
  [GROUP_MODAL_TYPE.RENAME_GROUP]: RenameGroupModal,
  [GROUP_MODAL_TYPE.JOIN_GROUP]: ApplyToJoinGroupModal,
  [GROUP_MODAL_TYPE.PIN_ARTICLE]: PinPostToGroupModal,
};

export const openGroupModal = (type: GROUP_MODAL_TYPE, config: any = {}) => {
  wrapModalPromise<any>(modalMap[type], {
    containerClassName: style.modal,
  })(config);
};
